<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport">
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        (onContentReady)="onContentReady($event)"
        (onRowDblClick)="onRowDblClick($event)"
    >
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxi-column dataField="car_status" caption="Car Status"></dxi-column>
        <dxi-column caption="Car ID">
            <dxi-column dataField="car_init" caption="Car Init"></dxi-column>
            <dxi-column dataField="car_no" caption="Car No"></dxi-column>
        </dxi-column>
        <dxi-column
            dataField="ship_date_time"
            caption="Ship Date"
            dataType="date"
            format="MM/dd/yy"
        ></dxi-column>
        <dxi-column dataField="cust_name" caption="Consignee Name"></dxi-column>
        <dxi-column dataField="inbound_outbound" caption="INB/OUT"></dxi-column>
        <dxi-column
            dataField="cust_origin_eda_eta"
            caption="ETA"
            dataType="datetime"
            format="MM/dd/yy HH:mm"
        ></dxi-column>
        <dxi-column
            dataField="arrival_close_date_time"
            caption="Actual Arrival"
            dataType="datetime"
            format="MM/dd/yy HH:mm"
        ></dxi-column>
        <dxi-column dataField="variance" caption="Variance"></dxi-column>
        <dxi-column caption="Origin">
            <dxi-column dataField="orig_city" caption="City"></dxi-column>
            <dxi-column dataField="orig_state" caption="State"></dxi-column>
        </dxi-column>
        <dxi-column caption="Destination">
            <dxi-column dataField="dest_city" caption="City"></dxi-column>
            <dxi-column dataField="dest_state" caption="State"></dxi-column>
        </dxi-column>
        <dxi-column dataField="fleet_id" caption="Fleet"></dxi-column>
        <dxi-column dataField="business_group" caption="Bus Group"></dxi-column>
        <dxi-column dataField="trip_status" caption="Trip Status"></dxi-column>
        <dxi-column dataField="shop_move" caption="Shop Move"></dxi-column>
        <dxi-column dataField="free_runner" caption="Free Runner"></dxi-column>
        <dxi-column dataField="divert_yorn" caption="Divert?"></dxi-column>
        <dxi-column dataField="bad_order_days" caption="Bad Order Days"></dxi-column>
        <dxi-column dataField="one_way_round" caption="One Way Round"></dxi-column>
        <dxi-column dataField="eta_manual_close" caption="Manual Close"></dxi-column>
        <dxi-column dataField="off_route_status" caption="Off Route"></dxi-column>
        <dxi-column caption="Destination Arrival">
            <dxi-column
                dataField="dest_arr_date_time"
                caption="Date"
                dataType="datetime"
                format="MM/dd/yy HH:mm"
            ></dxi-column>
            <dxi-column dataField="dest_arr_type" caption="Type"></dxi-column>
        </dxi-column>
        <dxi-column caption="Cust Delivery">
            <dxi-column
                dataField="cust_dlv_date_time"
                caption="Date"
                dataType="datetime"
                format="MM/dd/yy HH:mm"
            ></dxi-column>
            <dxi-column dataField="cust_dlv_type" caption="Type"></dxi-column>
        </dxi-column>
        <dxi-column caption="Cust Release">
            <dxi-column
                dataField="cust_rel_date_time"
                caption="Date"
                dataType="datetime"
                format="MM/dd/yy HH:mm"
            ></dxi-column>
            <dxi-column dataField="cust_rel_type" caption="Type"></dxi-column>
        </dxi-column>
        <dxi-column caption="Trip Close">
            <dxi-column
                dataField="trip_cls_date_time"
                caption="Date"
                dataType="datetime"
                format="MM/dd/yy HH:mm"
            ></dxi-column>
            <dxi-column dataField="trip_cls_type" caption="Type"></dxi-column>
        </dxi-column>
        <dxi-column caption="Current Location">
            <dxi-column dataField="loc_city" caption="City"></dxi-column>
            <dxi-column dataField="loc_state" caption="State"></dxi-column>
        </dxi-column>
        <dxi-column dataField="sight_code" caption="CLM Code"></dxi-column>
        <dxi-column
            dataField="clm_date_time"
            caption="CLM Date"
            dataType="datetime"
            format="MM/dd/yy HH:mm"
        ></dxi-column>
        <dxi-column dataField="le" caption="L/E"></dxi-column>
        <dxi-column dataField="road" caption="Road"></dxi-column>
        <dxi-column dataField="trn_jct" caption="Trn/Jct"></dxi-column>
        <dxi-column dataField="COMMENTS" caption="Comments"></dxi-column>
    </dx-data-grid>
    <div style="text-align: right; padding: 10px; font-weight: bold">
        Total Count: {{ totalCount }}
    </div>
</div>
